import './ZoomControls.css';

interface ZoomControlsProps {
  onZoomIn: VoidFunction;
  onZoomOut: VoidFunction;
  onResetZoom: VoidFunction;
  onResetToInitial: VoidFunction;
}

export const ZoomControls: React.FC<ZoomControlsProps> = ({
  onZoomIn,
  onZoomOut,
  onResetZoom,
  onResetToInitial,
}) => {
  return (
    <div className="container">
      <button
        type="button"
        onClick={onZoomIn}
        className="polly-btn x-small control-button"
        aria-label="Zoom in"
      >
        +
      </button>
      <button
        type="button"
        onClick={onZoomOut}
        className="polly-btn x-small control-button cursor-pointer d-flex justify-content-center align-items-center"
        aria-label="Zoom out"
      >
        -
      </button>
      <button
        type="button"
        onClick={onResetZoom}
        className="polly-btn x-small control-button"
        aria-label="Fit to view"
      >
        □
      </button>
    </div>
  );
};
